class Video {

  /**
   * Constructor:
   * Partial constructor called in `home.js` file.
   *
   * @constructor
   * @param {Object} options - Footer class options
   */
  constructor({el}) {
    // Root
    this.$root = el;

    // Init
    this.init();
  }

  init() {
    this.$root.forEach((el) => {
      let isLoaded = true;
      let video = el.querySelector('.js-video');
      let isEnter = false;
      let isOut = true;
      let isPlaying = false;

      //Wait for the video to be loaded
      // video.onloadeddata = () => {
      //   console.log('loaded');
      //   isLoaded = true;
      // };

      el.addEventListener('mouseover', (e) => {
        isEnter = true;
        isOut = false;
      });
      el.addEventListener('mouseenter', (e) => {
        isEnter = true;
        isOut = false;
      });

      el.addEventListener('mouseout', (e) => {
        isEnter = false;
        isOut = true;
      });

      setInterval(() => {
        if (!isLoaded) {
          return;
        }

        if (isEnter && !isPlaying) {
          let playPromise = video.play();

          if (playPromise !== undefined) {
            return playPromise.then(_ => {
              video.classList.add('active');
              isPlaying = true;
            }).catch(error => {
              el.click();
            });
          }
        }

        if (isOut && isPlaying) {
          video.pause();
          // video.classList.remove('active');
          isPlaying = false;
        }
      }, 200);

    });
  }
}

export default Video;
